export const getRiskAssessmentItems = () => [
  {
    title: "<strong>1. Henkilökohtaisien suojavarusteiden tarkastus?</strong>",
    id: "personalProtection",
    done: null,
    levels: { 2: "OK", 0: "EI OK" },
    required: true,
    mode: "execution",
  },
  {
    title:
      "<strong>2. Sisältääkö harjoitus korkean riskin harjoitteita?</strong>",
    id: "highRisk",
    done: null,
    type: "switch",
    value: false,
    levels: { 2: "Ei", 1: "Kyllä" },
  },
  {
    title: "2.1 Sisältääkö harjoitus <strong>savusukellusta?</strong>",
    id: "smokeDiving",
    done: null,
    type: "switch",
    value: false,
    levels: { 2: "Ei", 1: "Kyllä" },
    dependsOn: "highRisk",
  },
  {
    title: "2.1.1 Onko harjoitussuunnitelma laadittu ja tallennettu?",
    id: "smokeDivingPlan",
    done: null,
    levels: { 2: "Kyllä", 0: "Ei" },
    dependsOn: "smokeDiving",
    required: true,
    mode: "execution",
  },
  {
    title:
      "2.2 Sisältääkö harjoitus <strong>putoamisvaarallisella alueella työskentelyä?</strong>",
    id: "highWork",
    type: "switch",
    value: false,
    dependsOn: "highRisk",
    done: null,
  },
  {
    title: "2.2.1 Onko harjoitussuunnitelma laadittu ja tallennettu?",
    id: "highWorkPlan",
    done: null,
    levels: { 2: "Kyllä", 0: "Ei" },
    dependsOn: "highWork",
    required: true,
    mode: "execution",
  },
  {
    title: "2.3 Sisältääkö harjoitus <strong>pintapelastusta?</strong>",
    id: "surfaceRescue",
    type: "switch",
    value: false,
    dependsOn: "highRisk",
    done: null,
  },
  {
    title: "2.3.1 Onko harjoitussuunnitelma laadittu ja tallennettu?",
    id: "surfaceRescuePlan",
    done: null,
    levels: { 2: "Kyllä", 0: "Ei" },
    dependsOn: "surfaceRescue",
    required: true,
    mode: "execution",
  },

  {
    title: "2.4 Sisältääkö harjoitus <strong>kemikaalisukellusta?</strong>",
    id: "chemicalDiving",
    type: "switch",
    value: false,
    dependsOn: "highRisk",
    done: null,
  },
  {
    title: "2.4.1 Onko harjoitussuunnitelma laadittu ja tallennettu?",
    id: "chemicalDivingPlan",
    done: null,
    levels: { 2: "Kyllä", 0: "Ei" },
    dependsOn: "chemicalDiving",
    required: true,
    mode: "execution",
  },

  {
    title: "2.5 Sisältääkö harjoitus <strong>moottorisahan käyttöä?</strong>",
    id: "chainsaw",
    type: "switch",
    value: false,
    dependsOn: "highRisk",
    done: null,
  },
  {
    title: "2.5.1 Onko harjoitussuunnitelma laadittu ja tallennettu?",
    id: "chainsawPlan",
    done: null,
    levels: { 2: "Kyllä", 0: "Ei" },
    dependsOn: "chainsaw",
    required: true,
    mode: "execution",
  },
  {
    title:
      "2.6 Sisältääkö harjoitus <strong>työskentelyä tiealueella?</strong>",
    id: "roadwork",
    type: "switch",
    value: false,
    dependsOn: "highRisk",
    done: null,
  },
  {
    title: "2.6.1 Onko harjoitussuunnitelma laadittu ja tallennettu?",
    id: "roadworkPlan",
    done: null,
    levels: { 2: "Kyllä", 0: "Ei" },
    dependsOn: "roadwork",
    required: true,
    mode: "execution",
  },
  {
    title: "<strong>3. Esiintyykö harjoituksessa altisteita?</strong>",
    id: "exposure",
    done: null,
    type: "switch",
    value: false,
  },
  {
    title: "3.1 Altistutaanko harjoituksessa <strong>melulle?</strong>",
    id: "exposureNoise",
    done: null,
    type: "switch",
    value: false,
    dependsOn: "exposure",
  },
  {
    title: "3.1.1 Kuulosuojaimien käytön ohjeistus?",
    id: "exposureNoiseInstructions",
    done: null,
    levels: { 2: "Ei", 0: "Kyllä" },
    dependsOn: "exposureNoise",
    required: true,
    mode: "execution",
  },
  {
    title:
      "3.2 Altistutaanko harjoituksessa <strong>hengitysilman epäpuhtauksille?</strong>",
    id: "exposureAirImpurities",
    done: null,
    type: "switch",
    value: false,
    dependsOn: "exposure",
  },
  {
    title: "3.2.1 Suojaimien käytön ohjeistus?",
    id: "exposureAirImpuritiesInstructions",
    done: null,
    levels: { 2: "Ei", 0: "Kyllä" },
    dependsOn: "exposureAirImpurities",
    required: true,
    mode: "execution",
  },

  {
    title:
      "3.3 Altistutaanko harjoituksessa <strong>mahdollisille silmiin kohdistuville roiskeille?</strong>",
    id: "exposureEyeSplash",
    done: null,
    type: "switch",
    value: false,
    dependsOn: "exposure",
  },
  {
    title: "3.3.1 Suojaimien käytön ohjeistus?",
    id: "exposureEyeSplashInstructions",
    done: null,
    levels: { 2: "Ei", 0: "Kyllä" },
    dependsOn: "exposureEyeSplash",
    required: true,
    mode: "execution",
  },

  {
    title:
      "3.4 Altistutaanko harjoituksessa <strong>rajoitetussa näkyvyydessä työskentelyyn?</strong>",
    id: "exposureImpairedVisibility",
    done: null,
    type: "switch",
    value: false,
    dependsOn: "exposure",
  },
  {
    title: "3.4.1 Valaistuksen käytön ohjeistus?",
    id: "exposureImpairedVisibilityInstructions",
    done: null,
    levels: { 2: "Ei", 0: "Kyllä" },
    dependsOn: "exposureImpairedVisibility",
    required: true,
    mode: "execution",
  },

  {
    title:
      "3.5 Altistutaanko harjoituksessa <strong>liikkumiseen liukkaalla alustalla?</strong>",
    id: "exposureSlipperySurface",
    done: null,
    type: "switch",
    value: false,
    dependsOn: "exposure",
  },
  {
    title: "3.5.1 Liukkauden torjunnan ohjeistus?",
    id: "exposureSlipperySurfaceInstructions",
    done: null,
    levels: { 2: "Ei", 0: "Kyllä" },
    dependsOn: "exposureSlipperySurface",
    required: true,
    mode: "execution",
  },
  {
    title:
      "<strong>4. Käytiinkö keskustelu suojaimien käytön ja niiden mahdollisten puutteiden ilmoittamisen velvollisuudesta?</strong>",
    id: "discussionPersonalProtection",
    done: null,
    levels: { 2: "Kyllä", 0: "Ei" },
    required: true,
    mode: "execution",
  },
  {
    title: "SA511 Ryhmänjohtajan nimi",
    id: "sa511yj",
    type: "text",
    done: null,
    textValue: "",
    mode: "execution",
  },
  {
    title: "SA5112 Ryhmänjohtajan nimi",
    id: "sa5112yj",
    type: "text",
    done: null,
    textValue: "",
    mode: "execution",
  },
  {
    title: "Harjoituksen kouluttaja, ilmoittaa yllä olevat tiedot oikeiksi:",
    id: "vastuukouluttaja",
    type: "text",
    done: null,
    textValue: "",
    required: true,
    mode: "execution",
  },
];

export const findDeepnessLevel = (ep, arr, level = 0) => {
  if (!ep || !ep.dependsOn) return level + 1;
  return findDeepnessLevel(
    arr.find((a) => a.id === ep.dependsOn),
    arr,
    level + 1
  );
};

export const processRiskAssessmentItems = (items) => {
  return items.map((c, idx, arr) => {
    if (!c.levels) c.levels = { 2: "Ei", 1: "Kyllä", 0: "Ei tiedossa" };
    if (c.dependsOn) c.deepnessLevel = findDeepnessLevel(c, arr, 0);
    else c.deepnessLevel = 1;
    c.deepnessLevel = c.deepnessLevel - 1;
    return c;
  });
};
